var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoading
    ? _c(
        "div",
        { staticClass: "global-loader" },
        [
          _c("Loader", {
            staticClass: "global-loader__loader",
            attrs: { show: "", backdrop: "" },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }